import { ReduxAsyncActionsService } from '../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../types/ReduxAsyncActions.types';
import { INIT_STATE } from './BranchAccount.constants';
import type { BranchAccountState } from './BranchAccount.types';
import type { BranchAccountAction } from './actions';
import { GET_USER_BRANCH_ACCOUNT_ACTION_CONSTANTS } from './actions';

const handler = (
  state: WrappedReducer<BranchAccountState>,
  action: BranchAccountAction
): WrappedReducer<BranchAccountState> => {
  switch (action.type) {
    case GET_USER_BRANCH_ACCOUNT_ACTION_CONSTANTS.response:
      return { ...state, branchAccount: action.data, loading: false };

    default:
      return state;
  }
};

const BranchAccountReducer = ReduxAsyncActionsService.wrapReducer(INIT_STATE, handler, {
  request: [GET_USER_BRANCH_ACCOUNT_ACTION_CONSTANTS],
  error: [GET_USER_BRANCH_ACCOUNT_ACTION_CONSTANTS],
});

export default BranchAccountReducer;
